import { z } from "zod";

export const assetSchema = z.object({
  source: z.string(),
  type: z.string(),
});

export const createTicketBodySchema = z.object({
  title: z.string(),
  assets: z.array(assetSchema),
  contextAssets: z.array(assetSchema).optional(),
  context: z.string().optional(),
  /**
   * When true, the server will NOT trigger `FileProcessingWorkflow` for the
   * assets on this ticket. Set by callers that have already started upstream
   * processing (e.g. AskPuntt's `create_ticket` tool — `askPuntt.ts` fires
   * its own workflow at chat-upload time, so re-firing here would race on
   * the same GCS chunk and the loser fails with Gemini 400).
   */
  skipFileProcessing: z.boolean().optional(),
});

export type CreateTicketBody = z.infer<typeof createTicketBodySchema>;

export const createTicketRequest = z.object({
  body: createTicketBodySchema,
});

export const presignedURLRequestBody = z.object({
  fileName: z.string(),
  fileType: z.string(),
  isContextAsset: z.boolean().optional().default(false),
  assetContext: z
    .object({
      name: z.string().optional().nullable(),
      context: z.string().optional().nullable(),
      instructions: z.string().optional().nullable(),
      originalURL: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
});

export const presignedURLRequest = z.object({
  body: presignedURLRequestBody,
});

export const presignedURLResponse = z.object({
  url: z.string(),
  fields: z
    .object({
      key: z.string(),
      bucket: z.string(),
    })
    .passthrough(),
});
